"use strict";

var classNames = require("classnames");

var HtmlHelper = require("../shared/HtmlHelper");

var Frequency = React.createClass({
	propTypes: {
		isDesignMode: React.PropTypes.bool, //can do .isRequired
		tangible: React.PropTypes.object,
		frequencies: React.PropTypes.array,
		type: React.PropTypes.oneOf(["button", "radio", "dropdown"]),
		context: React.PropTypes.string,
		theme: React.PropTypes.string,
		isCustomTheme: React.PropTypes.bool,
		childClass: React.PropTypes.string,
		dataComponentId: React.PropTypes.string,
		dataNestedId: React.PropTypes.string,
		dataRepeatedId: React.PropTypes.string,

		tangibleActions: React.PropTypes.object,
		tangibleStore: React.PropTypes.object,
		thisArg: React.PropTypes.object,
		tangibleType: React.PropTypes.string,
		displayCodeProperty: React.PropTypes.string,
		reactComponentCategory: React.PropTypes.string,
		beginningComponentName: React.PropTypes.string
	},

	handleFrequencySelected: function (event) {
		var selectedFrequency = event.currentTarget.value;

		this._setFrequency(selectedFrequency);
	},

	_setFrequency: function (selectedFrequency) {
		var { tangibleType } = this.props;

		// if we're handling a pledge frequency change, we need to send along the associated project code as well.
		if (tangibleType === "pledge")
		{
			var pledge = this.props[tangibleType];
			var projectCode = this.props.isDesignMode ? "PROJ001" : pledge ? pledge.displayObject.value["DefaultProjectCode"] : null;

			if (pledge && projectCode) {
				this.props.tangibleActions.setFrequency(selectedFrequency, this.state.tangibleCode, projectCode, this.state.context);
			}
		} else {
			this.props.tangibleActions.setFrequency(selectedFrequency, this.state.tangibleCode, this.state.context);
		}
	},

	_onChange: function () {
		this.setState(this.props.tangibleStore.getState());
	},

	componentWillMount: function() {
		//Setting an instance Id, mainly for when we are in the searchResults and this component is in the grid and list view.  We need the names for the radio button groups to be unique.
		this.instanceId = HtmlHelper.getId($("body"));
	},

	componentDidMount: function () {
		if (this.props.isDesignMode) {
			//To add or remove react components from window, edit wwwroot\js\designer\ExposedComponents.jsx
			parent.window.ComponentActions.childComponentLoaded(this.props.thisArg || this);
		}
		var context = this.props.context;
		var contextId = "";
		if (context) {
			switch (context) {
				case "tangible":
					context = "category";
					contextId = $(ReactDOM.findDOMNode(this)).closest("[data-component=category]").attr("id");
					break;
				case "result":
					context = "search";
					contextId = $(ReactDOM.findDOMNode(this)).closest("[data-component=searchResults]").attr("id");
					break;
			}
			context += `_${contextId}`;
		}

		var selectedFrequency = this.state.selectedFrequency;
		if (!context) {
			// Check sessionStorage for cachedValues
			var cachedValues = {};
			if (this.props.tangibleActions.getCachedValues) {
				cachedValues = this.props.tangibleActions.getCachedValues() || {};
			}

			selectedFrequency = cachedValues.frequency || selectedFrequency;
		}

		this.setState({ context }, () => {
		// At this point, selectedFrequency has been set by the component
			this._setFrequency(selectedFrequency);
		});
		this.props.tangibleStore.addChangeListener(this._onChange);
	},

	componentWillUnmount: function () {
		this.props.tangibleStore.removeChangeListener(this._onChange);

		if (this.props.isDesignMode) {
			//To add or remove react components from window, edit wwwroot\js\designer\ExposedComponents.jsx
			parent.window.ComponentActions.childComponentUnloaded(this.props.thisArg || this);
			this.props.tangibleActions.setFrequency(null, this.state.tangibleCode, this.state.context);
		}
	},

	getDefaultProps: function () {
		return {
			beginningComponentName: "",
			type: "button",
			theme: "0",
			isCustomTheme: false
		};
	},

	getInitialState: function () {
		var selectedFrequency = null;
		var tangible = this.props[this.props.tangibleType];
		var frequencies = this.props.frequencies;
		var wizardFrequencies = { allowedFrequencies: [] };
		var frequency;
		var tangibleCode;
		var allowedFrequencies = [];
		var storeState = {isSponsorshipAvailable: true};

		// If we are on the client side
		if (typeof (window) !== "undefined") {
			storeState = this.props.tangibleStore.getState();

			// Ideally we would get the tangible from the store, but that does not exist on the server
			// We optimistically render on the server with the props.tangible (the @Model) and on the
			//  client, we will get the tangible from the store
			tangible = storeState[this.props.tangibleType] || this.props[this.props.tangibleType] || {};
			tangible = JSON.parse(JSON.stringify(tangible)); // clone the tangible to avoid reference
			frequencies = this.props.frequencies ? this.props.frequencies.slice(0) : []; // clone the array to avoid reference

			// We only want to set the initial state from the store if we're not in a repeater.
			if (!this.props.context) {
				selectedFrequency = storeState.selectedFrequency;
			}

			wizardFrequencies = storeState.wizardFrequencies;
			if (wizardFrequencies) {
				allowedFrequencies = wizardFrequencies.allowedFrequencies || [];
			}
		}

		if (allowedFrequencies && frequencies) {
			for (var i = frequencies.length - 1; i >= 0; --i) {
				frequency = frequencies[i];
				var allowedIndex = allowedFrequencies.indexOf(frequency.value);
				if (allowedIndex === -1) {
					// Frequency is not allowed
					frequencies.splice(i, 1);
				} else if (frequency.useDefaultDescription) {
					// Frequency should use default description
					frequency.description = wizardFrequencies[`${frequency.value}_Description`];
				}
			}
		} else {
			frequencies = [];
		}

		if (!selectedFrequency) {
			if (frequencies && frequencies.length > 0) {
				selectedFrequency = frequencies[0].value;
			} else {
				selectedFrequency = "";
			}
		}

		if (this.props.context) {
			if (this.props[this.props.tangibleType]) {
				tangibleCode = this.props[this.props.tangibleType].tangibleCode;
			} else if (this.props.isDesignMode) {
				tangibleCode = tangible[this.props.displayCodeProperty];
			}
		}

		return {
			selectedFrequency,
			tangible,
			tangibleCode,
			frequencies,
			isSponsorshipAvailable: storeState.isSponsorshipAvailable
		};
	},

	renderButton: function (selectedFrequency) {
		var context = this.state.context;
		var name = `${context ? `frequency_${context}_${this.state.tangibleCode}` : "frequency"}_${this.instanceId}`;

		return (
			<div className="frequencies">
				{this.state.frequencies.map(frequency => {
					var isSelected = selectedFrequency === frequency.value;

					return (
						<label
								className={classNames(["frequency", "radio-button", this.props.childClass, { selected: isSelected }])}
								data-override-classes={this.props.childClass}
								key={frequency.value}
								data-component={`${this.props.beginningComponentName}ButtonFrequency.button`}
						>
							<input type="radio" name={name} value={frequency.value} onChange={this.handleFrequencySelected} checked={isSelected} />
							<span>{frequency.description}</span>
						</label>
					);
				})}
			</div>
		);
	},

	renderRadio: function (selectedFrequency) {
		var context = this.state.context;
		var name = `${context ? `frequency_${context}_${this.state.tangibleCode}` : "frequency"}_${this.instanceId}`;

		return (
			<div className="frequencies">
				{this.state.frequencies.map((frequency) => {
					var isSelected = selectedFrequency === frequency.value;

					return (
						<label
								className={classNames(["frequency", this.props.childClass, { selected: isSelected }])}
								data-override-classes={this.props.childClass}
								key={frequency.value}
								data-component={`${this.props.beginningComponentName}RadioFrequency.radio`}
						>
							<input type="radio" name={name} value={frequency.value} onChange={this.handleFrequencySelected} checked={isSelected} />
							<span data-component={`${this.props.beginningComponentName}RadioFrequency.radio.label`}>{frequency.description}</span>
						</label>
					);
				})}
			</div>
		);
	},

	renderDropdown: function (selectedFrequency) {
		return (
			<div>
				<select
						className={classNames(["donation-frequencies", this.props.childClass])}
						style={this.props.isDesignMode ? {"pointerEvents": "none"} : undefined}
						data-override-classes={this.props.childClass}
						selected={selectedFrequency}
						onChange={this.handleFrequencySelected}
						data-component={`${this.props.beginningComponentName}SelectFrequency.select`}
						value={selectedFrequency || ""}
				>
					{this.state.frequencies.map((frequency) => {
						return (
							<option className="frequency" key={frequency.value} value={frequency.value}>
								{frequency.description}
							</option>
						);
					})}
				</select>
			</div>
		);
	},

	renderContainer: function () {
		var selectedFrequency;
		if (this.state.context) {
			selectedFrequency = this.props.tangibleStore.getSelectedFrequency(this.state.context, this.state.tangibleCode);
		} else {
			selectedFrequency = this.state.selectedFrequency;
		}

		switch (this.props.type) {
			case "button":
				return this.renderButton(selectedFrequency);
			case "radio":
				return this.renderRadio(selectedFrequency);
			case "dropdown":
				return this.renderDropdown(selectedFrequency);
			default:
				console.error("Invalid type for Frequency");
				return null;
		}
	},

	render: function () {
		var frequencies = this.state.frequencies;
		var tangible = this.state.tangible || {};
		var reactComponentName;

		if (tangible.PledgeType === "CHILD" && !this.state.isSponsorshipAvailable) {
			return null;
		}

		switch (this.props.type) {
			case "button":
				reactComponentName = "ButtonFrequency";
				break;
			case "radio":
				reactComponentName = "RadioFrequency";
				break;
			case "dropdown":
				reactComponentName = "SelectFrequency";
				break;
			default:
				console.error("Invalid type for Frequency");
				return null;
		}
		reactComponentName = this.props.beginningComponentName + reactComponentName;

		return (
			<div
				className="frequency"
				data-react-component-name={reactComponentName}
				data-react-component-category={this.props.reactComponentCategory}
				data-component-id={!this.props.isCustomTheme ? this.props.dataComponentId : undefined}
				data-nested-id={this.props.dataNestedId}
				data-repeated-id={this.props.dataRepeatedId}
				data-theme={+this.props.theme ? this.props.theme : undefined}
				data-custom={this.props.isCustomTheme || null}
				data-child-of={this.props.dataChildOf}
				tabIndex={this.props.isDesignMode ? -1 : undefined}
			>
				{frequencies && frequencies.length > 0 ?
					this.renderContainer()
				:
					<div className="collapsedComponentPlaceholder">{reactComponentName}</div>
				}
			</div>
		);
	}
});

module.exports = Frequency;



// WEBPACK FOOTER //
// ./Javascript/commonComponents/Frequency.jsx